import PropTypes from 'prop-types';

export default function OutlineContactSupport(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M18.522 13.333a1.889 1.889 0 0 1-1.89 1.89H6.779L3 19V3.889C3 2.846 3.846 2 4.889 2h11.744c1.043 0 1.889.846 1.889 1.889v9.444Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
            <path
                d="M8.09 6.603a2.399 2.399 0 0 1 4.662.8c0 1.599-2.4 2.398-2.4 2.398M10.418 12.5h.009"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineContactSupport.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
